import "./LeftTreeMenu.css"

import React from 'react';
// import { ListGroup, ListGroupItem } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import 'font-awesome/css/font-awesome.min.css';
import { Link } from "react-router-dom";
import { getRootUrl, getBkendUrl } from "../../consts";


const MenuItem = ({ item, isLast = false, onToggle }) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const subs = item.subs || [];
  const rootUrl = getRootUrl();
  
  const toggle = () => {
    setIsOpen(!isOpen);
    if (onToggle) {
      onToggle(item, !isOpen);
    }
  };
  return (
    <ListGroupItem>
      <div className="d-flex"
        onClick={evt=>{
            toggle();
        }}
      >
        {/* {subs.length > 0 && (
          <i 
            className={`fa fa-caret-${isOpen ? 'down' : 'right'} mr-3 cursor-pointer`} 
          />
        )} */}
        <i className="fa fa-folder-open me-2 mt-1" />
        {item.to?<Link
          to={`${rootUrl}/app3/${item.to}`}
        >{item.name}</Link>:<span title={item.note}>{item.name}</span>}

      </div>
      {isOpen && subs.length > 0 && (
        <ListGroup className="mt-2">
          {subs.map((sub, index) => (
            <MenuItem 
              key={index} 
              item={sub} 
              isLast={index === subs.length - 1}
              onToggle={onToggle}
            />
          ))}
        </ListGroup>
      )}
    </ListGroupItem>
  );
};
const TreeMenu = ({ items, onToggle }) => {
  return (
    <div className="mt-3 tree-menu">
      <ListGroup>
        {items.map((item, index) => (
          <MenuItem 
            key={index} 
            item={item} 
            isLast={index === items.length - 1}
            onToggle={onToggle}
          />
        ))}
      </ListGroup>
    </div>
  );
};

export default TreeMenu;